<template>
  <div class="col-12">
    <div class="st-meta float-right">
      <div class="element-actions">
        <div class="btn-group">
          <button
            aria-expanded="false"
            aria-haspopup="true"
            class="btn btn-secondary btn-md dropdown-toggle"
            data-toggle="dropdown"
            type="button"
          >
            <i class="fa fa-cogs"></i>
            
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <button
              class="dropdown-item"
              data-target="#modalFinalizarCarga"
              data-toggle="modal"
              href="#"
            >
              <i class="fas fa-truck"></i>
              Cambiar de asignación
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalFinalizarCarga"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h5 class="onboarding-title text-center">
                  Cambiar de asignación
                </h5>
              </div>
              <div>
                <div class="row">
                  <div class="col-sm-12">
                    <label>Barra de pedido</label>
                    <input
                      v-model="current.barra_pedido"
                      class="form-control"
                      placeholder="Barra de pedido"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.barra_pedido"
                      class="form-text text-danger"
                      >{{ current.errors.barra_pedido[0] }}</small
                    >
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <label>Barra de viaje</label>
                    <input
                      v-model="current.barra_viaje"
                      class="form-control"
                      placeholder="Barra de viaje"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.barra_viaje"
                      class="form-text text-danger"
                      >{{ current.errors.barra_viaje[0] }}</small
                    >
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    @click="cambiarAsignacionPedidoViaje()"
                    class="btn btn-primary"
                    type="submit"
                  >
                    Agregar
                  </button>
                  <button
                    class="btn btn-secondary"
                    ref="cerrarModalCarga"
                    data-dismiss="modal"
                    type="button"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {},
  components: {},
  data() {
    return {
      current: {
        barra_viaje: "",
        barra_pedido: "",
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    cambiarAsignacionPedidoViaje() {
      let self = this;
      DynamicService.postActionList(
        "cat",
        "viajes-reparto",
        "cambiar_asignacion_pedido_viaje",
        self.current
      )
        .then((response) => {
          $("#modalFinalizarCarga").modal("hide");
          Notifications.alert.success(
            "Cambiar de asignacion el pedido con el viaje",
            "Realizado correctamente"
          );
          self.current.barra_viaje = "";
          self.current.barra_pedido = "";
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Cambiar de asignacion el pedido con el viaje",
            errors.response.data.detail
          );
        });
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
  },
};
</script>
